import { useQuery, UseQueryResult } from 'react-query'
import { useSelector } from 'react-redux'
import { ONE_HOUR_IN_MS } from 'src/constants/time'
import { AvisoLexnet } from 'src/interfaces'
import { getAvisosLexnet } from 'src/services/AvisoLexnetService'
import { isAuthenticatedSelector } from 'src/state/authentication/selectors'

export default function useAvisosLexnet(
  isNew: boolean | null = null
): UseQueryResult<AvisoLexnet[], unknown> {
  const isUserAuthenticated = useSelector(isAuthenticatedSelector)
  return useQuery(['avisosLexnetListed', isNew], () => getAvisosLexnet(isNew), {
    enabled: isUserAuthenticated,
    staleTime: ONE_HOUR_IN_MS
  })
}
